<template>
  <div class="erm-page">
    <div class="erm-container">
      <!-- 面包屑导航 -->
      <nav class="breadcrumb-nav">
        <router-link to="/">首页</router-link>
        <span class="separator">/</span>
        <router-link to="/product">产品中心</router-link>
        <span class="separator">/</span>
        <span class="current">企业风险管理</span>
      </nav>
    </div>

    <!-- 英雄区 -->
    <section class="erm-container" style="padding-top: 20px;">
      <div style="max-width: 1000px;">
        <h1>企业风险矩阵与全面风险监督评价系统<br><span style="color: var(--erm-accent-blue);">风险热力图 · 量化矩阵 · 监督闭环</span></h1>
        <p class="subhead">构建风险识别、量化、展示、监督、整改一体化的数字化风险管理平台，助力企业实现全面风险管理（ERM）落地与审计成果最大化应用。</p>
        <div style="display: flex; gap: 20px; flex-wrap: wrap;">
          <a href="#" class="btn btn-primary" @click.prevent="openModal">预约演示 <i class="fa-regular fa-calendar-check" style="margin-left: 8px;"></i></a>
          <a href="#" class="btn btn-outline" @click.prevent="downloadBrochure">下载产品手册 <i class="fa-regular fa-file-pdf" style="margin-left: 8px;"></i></a>
        </div>
      </div>

      <!-- 关键词云（SEO强化） -->
      <div class="keyword-cloud">
        <h2 class="keyword-tag highlight">企业风险矩阵</h2>
        <h2 class="keyword-tag">风险管理系统</h2>
        <h2 class="keyword-tag">风险热力图</h2>
        <h2 class="keyword-tag">全面风险管理</h2>
        <h2 class="keyword-tag">风险评估</h2>
        <h2 class="keyword-tag">风险量化</h2>
        <h2 class="keyword-tag">风险监督评价</h2>
        <h2 class="keyword-tag">ERM</h2>
        <h2 class="keyword-tag">风险识别</h2>
        <h2 class="keyword-tag">风险预警</h2>
      </div>
    </section>

    <!-- 背景与挑战 -->
    <section class="erm-container">
      <h2><i class="fa-regular fa-triangle-exclamation"></i> 企业风险管理的核心挑战</h2>
      <div class="card-grid-3">
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-diagram-project"></i></div>
          <h3>风险识别不系统</h3>
          <p>风险分类不清晰、归口分散，缺乏统一风险视图，管理层难以掌握风险全貌。</p>
        </div>
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-chart-line"></i></div>
          <h3>风险量化能力不足</h3>
          <p>停留在定性判断，缺乏风险严重程度分析，风险金额与影响度无法量化。</p>
        </div>
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-rotate-left"></i></div>
          <h3>共性风险无法分析</h3>
          <p>屡查屡犯问题难以识别，风险趋势无法对比，同类风险跨年度无法追踪。</p>
        </div>
      </div>
      <p style="margin-top: 20px; font-size: 1.1rem;">数字经济时代，企业拥有海量数据，但风险分散在不同系统，缺乏集中化、可视化的风险管理平台，导致风险治理效率低下。</p>
    </section>

    <!-- 解决方案核心能力 -->
    <section class="erm-container">
      <h2><i class="fa-regular fa-cubes"></i> 四大核心能力 · 构建全面风险矩阵</h2>
      <div class="card-grid-4">
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-fire"></i></div>
          <h3>企业全面风险热力图</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 风险全景可视化</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 屡查屡犯风险识别</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 增加/减少趋势分析</li>
          </ul>
        </div>
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-border-all"></i></div>
          <h3>风险矩阵系统（核心）</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 概率/影响二维矩阵</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 2D/3D动态展示</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 下钻查看问题详情</li>
          </ul>
        </div>
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-chart-pie"></i></div>
          <h3>共性风险分析系统</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 问题频次分析</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 风险分布范围</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 多年度趋势对比</li>
          </ul>
        </div>
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-scale-balanced"></i></div>
          <h3>风险监督评价体系</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 定量+定性评分模型</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 风险等级自动划分</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 风险可衡量/可问责</li>
          </ul>
        </div>
      </div>
    </section>

    <!-- 风险矩阵深度展示 -->
    <section class="erm-container">
      <h2><i class="fa-regular fa-cube"></i> 风险矩阵 · 全景量化分析</h2>
      <div class="arch-card">
        <div style="display: flex; flex-wrap: wrap; gap: 20px; align-items: center; justify-content: center; margin-bottom: 30px;">
          <span class="compliance-badge">2D风险矩阵</span>
          <span class="compliance-badge">3D风险分布</span>
          <span class="compliance-badge">下钻分析</span>
          <span class="compliance-badge">趋势叠加</span>
        </div>
        <div class="arch-grid">
          <div class="arch-item">
            <i class="fa-regular fa-border-all" style="font-size: 2rem; color: var(--erm-primary-dark); margin-bottom: 16px; display: block;"></i>
            <h4>2D风险矩阵</h4>
            <p>横轴为风险发生概率，纵轴为影响程度，四象限划分重大/较大/一般/低风险，直观定位风险分布。</p>
          </div>
          <div class="arch-item">
            <i class="fa-regular fa-cube" style="font-size: 2rem; color: var(--erm-primary-dark); margin-bottom: 16px; display: block;"></i>
            <h4>3D风险展示</h4>
            <p>在2D基础上增加风险金额/数量作为高度维度，立体呈现风险权重，支持旋转/缩放查看。</p>
          </div>
          <div class="arch-item">
            <i class="fa-regular fa-magnifying-glass" style="font-size: 2rem; color: var(--erm-primary-dark); margin-bottom: 16px; display: block;"></i>
            <h4>下钻分析</h4>
            <p>点击矩阵任一区域，可查看具体风险点、涉及金额、责任单位、整改状态，追溯至原始审计问题。</p>
          </div>
        </div>
        <p style="margin-top: 30px; text-align: center;">风险矩阵与企业审计成果深度联动，实现"审计问题 → 风险矩阵 → 监督评价"一体化管理。</p>
      </div>
    </section>

    <!-- 应用场景 -->
    <section class="erm-container">
      <h2><i class="fa-regular fa-building"></i> 典型应用场景</h2>
      <div class="card-grid-3">
        <div class="feature-card">
          <h3>企业全面风险宏观展示</h3>
          <p>为集团风险管理委员会、审计委员会提供风险全景视图，一屏掌控企业风险分布与变化趋势。</p>
        </div>
        <div class="feature-card">
          <h3>风险识别与分类管理</h3>
          <p>识别高风险区域，进行风险分级管理，形成企业风险资产库，支撑年度审计计划制定。</p>
        </div>
        <div class="feature-card">
          <h3>共性风险跟踪与闭环评估</h3>
          <p>高频问题专项治理，风险整改进度追踪，实现风险发现 → 评价 → 整改 → 复盘 → 沉淀闭环。</p>
        </div>
      </div>
    </section>

    <!-- 项目成果与价值（数据指标） -->
    <section class="erm-container">
      <h2><i class="fa-regular fa-chart-simple"></i> 关键成果与价值</h2>
      <div class="stat-grid">
        <div class="stat-card">
          <div class="stat-number">100%</div>
          <p>风险统一视图</p>
        </div>
        <div class="stat-card">
          <div class="stat-number">30%+</div>
          <p>风险识别准确率提升</p>
        </div>
        <div class="stat-card">
          <div class="stat-number">50%+</div>
          <p>风险响应速度提升</p>
        </div>
        <div class="stat-card">
          <div class="stat-number">闭环</div>
          <p>风险整改可追溯</p>
        </div>
      </div>
      <div style="margin-top: 40px;">
        <ul style="list-style: none; display: flex; flex-wrap: wrap; gap: 30px; justify-content: center;">
          <li class="list-item"><i class="fa-regular fa-circle-check"></i> 实现风险全面可视化，管理层决策更直观</li>
          <li class="list-item"><i class="fa-regular fa-circle-check"></i> 风险提前识别预警，降低重大风险发生概率</li>
          <li class="list-item"><i class="fa-regular fa-circle-check"></i> 构建风险闭环管理体系，审计成果最大化应用</li>
          <li class="list-item"><i class="fa-regular fa-circle-check"></i> 推动企业全面风险管理（ERM）从经验式向数据驱动升级</li>
        </ul>
      </div>
    </section>

    <!-- 适用客户类型 -->
    <section class="erm-container">
      <h2><i class="fa-regular fa-users"></i> 适用客户群体</h2>
      <div class="client-tags">
        <span class="client-tag">中央企业集团</span>
        <span class="client-tag">地方国有企业</span>
        <span class="client-tag">金融机构</span>
        <span class="client-tag">能源/电力/通信企业</span>
        <span class="client-tag">制造业集团</span>
        <span class="client-tag">政府监管单位</span>
        <span class="client-tag">内部审计部门</span>
        <span class="client-tag">风险管理部门</span>
      </div>
    </section>

    <!-- 客户成功案例 -->
    <section class="erm-container">
      <h2><i class="fa-regular fa-briefcase"></i> 客户成功案例</h2>
      <div class="card-grid-3">
        <div class="case-card">
          <i class="fa-solid fa-building-columns" style="font-size: 2rem; color: var(--erm-primary-dark);"></i>
          <div class="case-stats">-35%</div>
          <p><strong>某能源央企</strong> — 通过风险矩阵系统，提前识别海外投资重大风险3起，避免潜在损失超5亿元。</p>
        </div>
        <div class="case-card">
          <i class="fa-solid fa-phone" style="font-size: 2rem; color: var(--erm-primary-dark);"></i>
          <div class="case-stats">+50%</div>
          <p><strong>省级通信集团</strong> — 风险热力图实现全省21家地市公司风险排名，高风险领域识别效率提升50%。</p>
        </div>
        <div class="case-card">
          <i class="fa-solid fa-truck" style="font-size: 2rem; color: var(--erm-primary-dark);"></i>
          <div class="case-stats">100%</div>
          <p><strong>大型制造企业</strong> — 将5年审计问题沉淀为风险矩阵资产，共性风险专项治理后整改率达到100%。</p>
        </div>
      </div>
    </section>

    <!-- 常见问题 FAQ -->
    <section class="erm-container">
      <h2 style="text-align: center;"><i class="fa-regular fa-circle-question"></i> 常见问题</h2>
      <div class="faq-list">
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 风险矩阵的维度如何定义？能否自定义？</div>
          <div class="faq-answer">系统预置通用风险分类（战略、财务、运营、合规等），并支持客户根据行业特点自定义风险维度、发生概率与影响程度权重。</div>
        </div>
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 风险数据来源有哪些？如何保证数据实时性？</div>
          <div class="faq-answer">可对接审计系统、ERP、财务系统、业务系统等，支持定时抽取或实时API同步，确保风险矩阵动态更新。</div>
        </div>
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 是否支持3D风险矩阵展示？</div>
          <div class="faq-answer">支持2D/3D切换展示，3D模式下以风险金额或问题数量为高度轴，更直观呈现风险权重，可旋转缩放。</div>
        </div>
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 如何实现风险整改闭环跟踪？</div>
          <div class="faq-answer">每个风险点可关联整改任务，实时跟踪整改进度、责任人、完成情况，并支持超期预警，确保风险闭环。</div>
        </div>
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 实施周期需要多久？</div>
          <div class="faq-answer">一般2-3个月完成试点上线，包括风险指标体系梳理、数据接入、模型配置和人员培训。提供敏捷交付模式。</div>
        </div>
      </div>
    </section>

    <!-- 最终CTA -->
    <section class="erm-container" style="padding-bottom: 80px;">
      <div class="cta-block">
        <h2 style="font-size: 2.4rem;">构建企业风险矩阵与监督评价体系</h2>
        <p style="font-size: 1.2rem; margin: 16px 0 40px; opacity: 0.9;">预约专家演示，了解如何将审计问题转化为风险矩阵资产，实现风险量化管理与闭环监督。</p>
        <div style="display: flex; gap: 20px; justify-content: center; flex-wrap: wrap;">
          <a href="#" class="btn btn-primary" @click.prevent="openModal" style="background: white; color: var(--erm-primary-dark);">预约免费演示</a>
          <a href="tel:4008881234" class="btn btn-outline" style="border-color: white; color: white;">致电 400-888-1234</a>
        </div>
        <p style="margin-top: 32px; font-size: 1rem;"><i class="fa-regular fa-envelope"></i> 发送需求至 riskmatrix@gushandata.cn</p>
      </div>
    </section>

    <!-- 预约演示模态框 -->
    <div class="modal" :style="{ display: showModal ? 'flex' : 'none' }">
      <div class="modal-content">
        <span class="close-modal" @click="closeModal">&times;</span>
        <h3><i class="fa-regular fa-calendar-check" style="color: var(--erm-primary-dark);"></i> 预约专家演示</h3>
        <form @submit.prevent="submitDemo">
          <div class="form-group">
            <input type="text" v-model="form.name" placeholder="姓名 *" required>
          </div>
          <div class="form-group">
            <input type="text" v-model="form.company" placeholder="公司名称">
          </div>
          <div class="form-group">
            <input type="email" v-model="form.email" placeholder="工作邮箱 *" required>
          </div>
          <div class="form-group">
            <input type="tel" v-model="form.phone" placeholder="联系电话">
          </div>
          <div class="form-group">
            <textarea rows="3" v-model="form.message" placeholder="您的需求或问题（选填）"></textarea>
          </div>
          <button type="submit" class="btn btn-primary">提交预约</button>
        </form>
      </div>
    </div>

    <!-- footer -->
    <footer class="erm-container">
      <p>© 2026 古杉数据 · 企业风险矩阵与全面风险监督评价系统 | 风险热力图 · 量化矩阵 · 监督闭环</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'EnterpriseRiskManagementDetail',
  data() {
    return {
      showModal: false,
      showQrModal: false,
      qrImages: [require('@/assets/img/qr_gu.jpg'), require('@/assets/img/qr_sang.jpg')],
      form: {
        name: '',
        company: '',
        email: '',
        phone: '',
        message: ''
      }
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    submitForm() {
      alert('表单已提交');
      this.showModal = false;
    },
    showQrCode() {
      this.showQrModal = true;
    },
    downloadBrochure() {
      alert('产品手册下载中…… (实际可替换为PDF链接)');
    }
  }
};
</script>

<style scoped>
.erm-page {
  --erm-primary-dark: #1D4E4E;
  --erm-primary-soft: #e9f3f2;
  --erm-accent-gold: #D4AF37;
  --erm-accent-blue: #2A7DE1;
  --erm-gray-light: #f8fafc;
  --erm-gray-border: #e2e8f0;
  --erm-text-dark: #0f2a2a;
  --erm-text-regular: #2d3f4b;
  --erm-white: #ffffff;
  --erm-shadow: 0 12px 30px rgba(0, 40, 40, 0.06);

  background-color: #ffffff;
  color: var(--erm-text-regular);
  line-height: 1.5;
  font-family: 'Inter', 'PingFang SC', 'Roboto', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
}

/* 面包屑导航 */
.breadcrumb-nav {
  padding: 20px 0;
  font-size: 0.9rem;
  border-bottom: 1px solid var(--erm-gray-border);
  margin-bottom: 20px;
}

.breadcrumb-nav a {
  color: var(--erm-primary-dark);
  text-decoration: none;
  font-weight: 500;
}

.breadcrumb-nav a:hover {
  text-decoration: underline;
}

.breadcrumb-nav .separator {
  margin: 0 8px;
  color: #999;
}

.breadcrumb-nav .current {
  color: var(--erm-accent-blue);
  font-weight: 600;
}

.erm-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
}

section.erm-container {
  padding: 64px 24px;
}

h1, h2, h3 {
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--erm-text-dark);
}

h1 {
  font-size: 3.2rem;
  line-height: 1.2;
}

h2 {
  font-size: 2.2rem;
  margin-bottom: 24px;
}

h2 i {
  color: var(--erm-accent-blue);
  margin-right: 8px;
}

h3 {
  font-size: 1.4rem;
  margin-bottom: 12px;
}

.subhead {
  font-size: 1.2rem;
  color: #4f6f7f;
  max-width: 800px;
  margin-bottom: 40px;
}

.btn {
  display: inline-block;
  padding: 12px 30px;
  border-radius: 40px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s;
  font-size: 1rem;
  border: 1px solid transparent;
  cursor: pointer;
}

.btn-primary {
  background-color: var(--erm-primary-dark);
  color: white;
  box-shadow: 0 4px 12px rgba(29, 78, 78, 0.25);
}

.btn-primary:hover {
  background-color: #0e3a3a;
  transform: translateY(-2px);
}

.btn-outline {
  background-color: transparent;
  border: 1.5px solid var(--erm-primary-dark);
  color: var(--erm-primary-dark);
}

.btn-outline:hover {
  background-color: var(--erm-primary-dark);
  color: white;
}

.btn-accent {
  background-color: var(--erm-accent-blue);
  color: white;
  box-shadow: 0 4px 12px rgba(42, 125, 225, 0.3);
}

.btn-accent:hover {
  background-color: #1b64c5;
  transform: translateY(-2px);
}

/* 关键词标签云 */
.keyword-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 30px 0 20px;
}

.keyword-tag {
  background: var(--erm-primary-soft);
  color: var(--erm-primary-dark);
  padding: 6px 16px;
  border-radius: 40px;
  font-size: 0.85rem;
  font-weight: 500;
  border: 1px solid transparent;
}

.keyword-tag.highlight {
  background: var(--erm-accent-gold);
  color: #1e3c3c;
}

/* 卡片网格 */
.card-grid-3, .card-grid-4 {
  display: grid;
  gap: 24px;
  margin: 40px 0;
}

.card-grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

.card-grid-4 {
  grid-template-columns: repeat(4, 1fr);
}

.feature-card {
  background: white;
  border-radius: 24px;
  padding: 28px 24px;
  box-shadow: var(--erm-shadow);
  border: 1px solid var(--erm-gray-border);
  transition: transform 0.2s;
}

.feature-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 40px rgba(29, 78, 78, 0.1);
}

.card-icon {
  font-size: 2.5rem;
  color: var(--erm-primary-dark);
  margin-bottom: 20px;
}

.list-item {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  align-items: flex-start;
}

.list-item i {
  color: var(--erm-accent-blue);
  font-size: 1.1rem;
  margin-top: 3px;
  min-width: 20px;
}

.stat-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-top: 40px;
}

.stat-card {
  background: var(--erm-primary-soft);
  border-radius: 32px;
  padding: 32px 24px;
  text-align: center;
}

.stat-number {
  font-size: 2.8rem;
  font-weight: 700;
  color: var(--erm-primary-dark);
  margin-bottom: 8px;
}

.client-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
}

.client-tag {
  background: white;
  border: 1px solid var(--erm-gray-border);
  padding: 8px 22px;
  border-radius: 40px;
  font-weight: 500;
  color: var(--erm-text-dark);
}

.case-card {
  background: white;
  border-radius: 24px;
  padding: 28px;
  box-shadow: var(--erm-shadow);
}

.case-stats {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--erm-primary-dark);
  margin: 16px 0 8px;
}

/* 技术架构卡片 */
.arch-card {
  background: var(--erm-primary-soft);
  border-radius: 32px;
  padding: 36px;
  margin-top: 30px;
}

.arch-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 24px;
}

.arch-item {
  background: white;
  border-radius: 24px;
  padding: 24px;
}

/* 合规认证 */
.compliance-badge {
  display: inline-block;
  background: var(--erm-accent-gold);
  color: #1e3c3c;
  padding: 8px 18px;
  border-radius: 40px;
  font-weight: 600;
  margin-right: 12px;
  margin-bottom: 12px;
}

/* FAQ */
.faq-list {
  max-width: 900px;
  margin: 40px auto 0;
}

.faq-item {
  padding: 22px 0;
  border-bottom: 1px solid var(--erm-gray-border);
}

.faq-question {
  font-weight: 700;
  font-size: 1.2rem;
  display: flex;
  gap: 16px;
  color: var(--erm-text-dark);
}

.faq-question i {
  color: var(--erm-accent-gold);
}

.faq-answer {
  margin-top: 12px;
  color: #3f5465;
  padding-left: 40px;
}

/* ============ 预约咨询区段 ============ */
.section {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 16px;
}
.cta-section {
  margin-bottom: 60px;
}
.cta-inner {
  background: linear-gradient(135deg, #EAF0FB 0%, #F6F8FC 100%);
  border: 1px solid #D6E2F5;
  border-radius: 24px;
  padding: 48px 40px;
  text-align: center;
  color: #0E1F52;
  box-shadow: 0 8px 32px rgba(14,31,82,0.08);
}
.cta-heading {
  font-size: 24px;
  font-weight: 700;
  color: #0E1F52;
  margin-bottom: 10px;
  line-height: 1.45;
}
.cta-sub {
  font-size: 14px;
  color: #5A5E66;
  margin-bottom: 32px;
}
.cta-actions {
  display: flex;
  gap: 14px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 24px;
}
.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 28px;
  border-radius: 50px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.25s;
  text-decoration: none;
}
.cta-btn--primary {
  background: #1F3F8F;
  color: #fff;
}
.cta-btn--primary:hover {
  background: #0E1F52;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(14,31,82,0.22);
}
.cta-btn--outline {
  background: #fff;
  color: #1F3F8F;
  border: 2px solid #1F3F8F;
}
.cta-btn--outline:hover {
  background: #EAF0FB;
  border-color: #0E1F52;
  color: #0E1F52;
  transform: translateY(-2px);
}
.cta-contact-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
  color: #7B8794;
  font-size: 12px;
}
.cta-contact-row i { margin-right: 4px; color: #1F3F8F; }
.cta-contact-row .divider { color: #CBD3E0; }

/* ============ 弹窗通用 ============ */
.modal-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(11,26,51,0.65);
  backdrop-filter: blur(4px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.modal-container {
  background: #fff;
  border-radius: 16px;
  width: 90%;
  max-width: 420px;
  box-shadow: 0 20px 60px rgba(14,31,82,0.22);
  overflow: hidden;
}
.modal-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 18px 22px 16px;
  border-bottom: 1px solid #EEF1F8;
  position: relative;
}
.modal-header-icon {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 12px;
  background: #EAF0FB;
  color: #1F3F8F;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.qr-header-icon {
  background: #e8f5e9;
  color: #07c160;
}
.modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #0E1F52;
  margin: 0 0 4px;
}
.modal-subtitle {
  font-size: 13px;
  color: #7b8794;
  margin: 0;
}
.modal-close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: #F4F6FB;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #5f6a7d;
  font-size: 14px;
  transition: background 0.2s;
}
.modal-close-btn:hover { background: #e2e8f4; }

/* 预约表单 */
.appt-form {
  padding: 16px 22px 22px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
@media (max-width: 480px) {
  .form-row { grid-template-columns: 1fr; }
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.form-group label {
  font-size: 13px;
  font-weight: 600;
  color: #2B2F3A;
}
.form-group .required { color: #e55353; }
.form-group input,
.form-group select,
.form-group textarea {
  padding: 8px 12px;
  border: 1.5px solid #E0E6F0;
  border-radius: 8px;
  font-size: 13px;
  color: #2B2F3A;
  background: #FAFBFD;
  transition: border-color 0.2s, box-shadow 0.2s;
  outline: none;
  resize: vertical;
}
.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border-color: #1F3F8F;
  box-shadow: 0 0 0 3px rgba(31,63,143,0.1);
  background: #fff;
}
.form-submit-btn {
  width: 100%;
  padding: 11px;
  background: #1F3F8F;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.2s, transform 0.2s;
  margin-top: 4px;
}
.form-submit-btn:hover {
  background: #0e3170;
  transform: translateY(-1px);
}
.form-privacy {
  text-align: center;
  font-size: 12px;
  color: #9ca3af;
  margin: -4px 0 0;
}
.form-privacy i { margin-right: 4px; }

/* 二维码弹窗 */
.qr-modal { max-width: 560px; }
.qr-grid {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
  padding: 24px 28px;
}
.qr-card {
  flex: 1;
  min-width: 180px;
  max-width: 220px;
  background: #F8FAFF;
  border-radius: 16px;
  border: 1px solid #E0E8F8;
  padding: 20px 16px 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.qr-img-wrap {
  width: 160px;
  height: 160px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #dde5f5;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.qr-img { width: 100%; height: 100%; object-fit: cover; display: block; }
.qr-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #9ca3af;
  font-size: 13px;
}
.qr-placeholder i { font-size: 36px; color: #07c160; opacity: 0.5; }
.qr-card-label {
  font-size: 13px;
  font-weight: 600;
  color: #0E1F52;
  line-height: 1.4;
}
.qr-scan-hint {
  font-size: 12px;
  color: #9ca3af;
}
.qr-scan-hint i { margin-right: 4px; }
.qr-footer-tip {
  text-align: center;
  font-size: 13px;
  color: #7b8794;
  padding: 0 28px 22px;
  margin: 0;
}
.qr-footer-tip strong { color: #0E1F52; }

/* 弹窗入场动画 */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;
}
.modal-fade-enter-active .modal-container,
.modal-fade-leave-active .modal-container {
  transition: transform 0.25s ease, opacity 0.25s ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to { opacity: 0; }
.modal-fade-enter-from .modal-container,
.modal-fade-leave-to .modal-container {
  transform: translateY(24px) scale(0.97);
  opacity: 0;
}

footer {
  text-align: center;
  padding: 40px 0;
  color: #7f8d9c;
  border-top: 1px solid var(--erm-gray-border);
  margin-top: 40px;
}

/* 响应式 */
@media (max-width: 1000px) {
  .card-grid-3, .card-grid-4, .stat-grid, .arch-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 700px) {
  .card-grid-3, .card-grid-4, .stat-grid, .arch-grid {
    grid-template-columns: 1fr;
  }
  .erm-page h1 { font-size: 2.5rem; }
}
</style>
